import HttpService from "./HttpService";

const getRequests = (status) =>
  HttpService.getAxiosClient().get(
    `${window.API_URL}/proof-of-funds?status=${encodeURIComponent(status)}`
  );

const getRequest = (paymentRequestId) =>
  HttpService.getAxiosClient().get(
    `${window.API_URL}/proof-of-funds/${encodeURIComponent(paymentRequestId)}`
  );

const decideRequest = (paymentRequestId, decision, reason) =>
  HttpService.getAxiosClient().post(
    `${window.API_URL}/proof-of-funds/${encodeURIComponent(paymentRequestId)}/decision`,
    { decision, reason }
  );

const uploadDocument = (paymentRequestId, file) =>
  HttpService.getAxiosClient().post(
    `${window.API_URL}/proof-of-funds/${encodeURIComponent(
      paymentRequestId
    )}/documents`,
    file
  );

const downloadDocument = (documentId, companyId, original = false) =>
  HttpService.getAxiosClient().get(
    `${window.API_URL}/member/kyc-documents/${documentId}/download?companyId=${encodeURIComponent(
      companyId
    )}&original=${original}`,
    { responseType: "blob" }
  );

const ProofOfFundsService = {
  getRequests,
  getRequest,
  decideRequest,
  uploadDocument,
  downloadDocument,
};

export default ProofOfFundsService;
